module.exports = __webpack_public_path__ + "img/y- (3).4b0d64cf.png";